module.exports = __webpack_public_path__ + "_/img/bag_centered.27db55fc.jpg";